import React from "react"
import "./styles/MapLogo.scss"

interface MapLogoProps {
  position?: "top-left" | "top-right" | "bottom-left" | "bottom-right"
}

const MapLogo: React.FC<MapLogoProps> = ({ position = "bottom-left" }) => {
  return (
    <a href="https://vibemap.com" target="_blank" rel="noopener noreferrer" className={`map-logo ${position}`}>
      <img src="https://ik.imagekit.io/vibemap/Logotype_Vibemap-Logotype-Black_FX7ogm-xg.png" alt="Logo" />
    </a>
  )
}

export default MapLogo
